import { render } from "./HeroiconsOutlineChevronDoubleLeft.vue?vue&type=template&id=0a716213"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleLeft.vue"]])

export default __exports__